/** Pieces the Sprout Buddy's drawing files share. */

export const INK = '#2B1D14'
export const W = 3 // outline width

/** The teardrop body. Materials clip to it; poses hang off it. */
export const BODY = 'M60 36 C74 48 96 72 96 100 C96 124 80 138 60 138 C40 138 24 124 24 100 C24 72 46 48 60 36 Z'

/** A four-pointed glint. */
export function sparkle(x: number, y: number, s: number, k: string, fill = '#FFFFFF') {
  return (
    <path key={k} className="ws-buddy-twinkle"
      d={`M${x} ${y - s} L${x + s * 0.3} ${y - s * 0.3} L${x + s} ${y} L${x + s * 0.3} ${y + s * 0.3} L${x} ${y + s} L${x - s * 0.3} ${y + s * 0.3} L${x - s} ${y} L${x - s * 0.3} ${y - s * 0.3} Z`}
      fill={fill} style={{ animationDelay: `${(x + y) % 7 / 5}s` }} />
  )
}

/** CSS for a swatch, from the same stops the body uses. */
export function linearCss(angle: number, stops: [number, string][]): string {
  return `linear-gradient(${angle}deg,${stops.map(([at, c]) => `${c} ${Math.round(at * 100)}%`).join(',')})`
}
